<div class="p-1 mb-1 d-flex align-items-center navigation">
  <div class="flex-grow-1 font-weight">
    <button class="btn px-0" type="button" (click)="titleClick.emit()">
      <ng-content></ng-content>
      <fa-icon [icon]="['fas', 'angle-down']" size="xs" class="ml-1"></fa-icon>
    </button>
  </div>
  <button
    class="btn btn-outline-light px-2 py-1 py-0 mr-1"
    type="button"
    (click)="previous.emit()"
    data-e2e="prev-month"
  >
    <fa-icon [icon]="['fas', 'angle-left']" size="xs"></fa-icon>
  </button>
  <button
    class="btn btn-outline-light px-2 py-1 p-0"
    type="button"
    (click)="next.emit()"
    data-e2e="next-month"
  >
    <fa-icon [icon]="['fas', 'angle-right']" size="xs"></fa-icon>
  </button>
</div>
